export { BaseProductListComponent } from './base-product-list/base-product-list.component';
export { BaseProductSelectorInputComponent } from './base-product-select-input/base-product-select-input';

import { registerRouteComponent } from '@vendure/admin-ui/core';
import { BaseProductListComponent } from './base-product-list/base-product-list.component';
import { BaseProductDetailComponent } from './base-product-detail/base-product-detail.component';
import { GetBaseProductDocument } from '../../gql/graphql';

export const BaseProductRoutes = [
  registerRouteComponent({
    path: 'base-product',
    component: BaseProductListComponent,
    breadcrumb: [
      {
        label: 'Produto Base',
        link: ['/extensions', 'grupo-loja', 'base-product'],
      },
    ],
  }),
  registerRouteComponent({
    path: 'base-product/:id',
    component: BaseProductDetailComponent,
    query: GetBaseProductDocument,
    entityKey: 'baseProduct',

    getBreadcrumbs: entity => [
      {
        label: 'Produto Base',
        link: ['/extensions', 'grupo-loja', 'base-product'],
      },
      {
        label: entity ? `#${entity?.name}` : 'Novo Produto Base',
        link: [],
      },
    ],
  }),
];
